import axios from 'axios';

const getAvaliacao = (idComprador) => axios.get(`/comprador/${idComprador}/avaliacao`);

export default {
  getAvaliacao,
};
